import { render } from "./SearchInputField.vue?vue&type=template&id=3c71d386"
import script from "./SearchInputField.vue?vue&type=script&lang=js"
export * from "./SearchInputField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__